module.exports = __webpack_public_path__ + "img/avatar.7358237d.webp";